import { formatInt, formatNumber, formatToKM } from "Helpers/numbers";

export const formatNumberValue = (
  val: unknown,
  currency?: string,
  options?: { isKM?: boolean },
) => (options?.isKM ? formatToKM(Number(val)) : formatNumber(Number(val)));

export const formatIntegerValue = (
  val: unknown,
  currency?: string,
  options?: { isKM?: boolean },
) =>
  options?.isKM ? formatToKM(Number(val)) : formatInt(Math.round(Number(val)));
